<div class="ng-Header col-xs-12">
  <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Previous STP Applications
</div>

  <nz-table
    [nzData]="stpList"
    [nzTotal]="total"
    [(nzPageSize)]="size"
    [(nzPageIndex)]="page"
    [nzFrontPagination]="false"
    (nzQueryParams)="onQueryParamsChange($event)"
    [nzLoading]="loading"
    nzBordered
    nzSize="middle"
    [nzScroll]="{ x: '1150px' }"
    nzTableLayout="fixed"
    nzShowSizeChanger
    nzAlign="middle"
    [nzShowTotal]="totalRowRangeTemplate"
  >
  <ng-template #totalRowRangeTemplate let-range="range" let-total style="text-align: left">
    <div style="text-align: left">
      Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
    </div>
  </ng-template>
    <thead>
    <tr>
      <th style="text-align: center;">Sl.</th>
      <th>STP Name</th>
      <th>Application ID</th>
      <th>Application Date</th>
      <th>Registration Number</th>
      <th>District</th>
      <th>Approval Status</th>
      <th>Approval Date</th>
      <th>Expire Date</th>
      <th>Renewed?</th>
      <th>Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of stpList; let i = index">
      <td style="text-align: center">{{ (page - 1) * size + i + 1 }}</td>
      <td>{{ item.stpName }}</td>
      <td>{{ item.applicationId }}</td>
      <td>{{ item.applicationDate | date: 'dd-MM-yyyy' }}</td>
      <td>{{ item.registrationNo }}</td>
      <td>{{ item.districtName }}</td>
      <td>
          <span
            class="badge"
            [ngClass]="{
              'badge-success': item.isApproved,
              'badge-danger': !item.isApproved
            }"
          >
            {{ item.isApproved ? 'Approved' : 'Not Approved' }}
          </span>
      </td>
      <td>{{ item.approvalDate | date: 'dd-MM-yyyy' }}</td>
      <td>{{ item.expireDate | date: 'dd-MM-yyyy' }}</td>
      <td>
          <span
            class="badge"
            [ngClass]="{
              'badge-success': item.isRenewed,
              'badge-danger': !item.isRenewed
            }"
          >
            {{ item.isRenewed ? 'Yes' : 'No' }}
          </span>
      </td>
      <td>
        <button
                style="margin: 2px"
                nz-button
                nzType="primary"
                title="View Application"

        >
               <span >
                  <a [routerLink]="['/home/stp-registration/previous-stp-application-view/' + item.stpMainId+'/'+item.applicationId]"
                     target="_blank"
                     routerLinkActive="router-link-active"
                  ><i nz-icon nzType="eye" style="color: white" nzTheme="outline"></i></a>
                </span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
